(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8818],{

/***/ 9246:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album",
      function () {
        return __webpack_require__(66129);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3829,5897,9072,9477,231,5616,9705,6541,168,2100,9318,6348,9531,3756,6245,6007,6481,6129,9774,2888,179], function() { return __webpack_exec__(9246); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);